export default __webpack_public_path__ + "static/media/bak_lewc_seal.b44e8665.png";